export const MAX_DONATION_FILE_PROOF_COUNT = 1 as const; 
export const MAX_DONATION_FILE_PROOF_SIZE = 10_000_000 as const;